import React from "react";
import { MultiSelect, Textfield } from "../../../../../../components/core";
import DateRangeTimePicker from "../../../../../../components/core/date-range-with-time-picker";
import { useSelector } from "react-redux";
import PrimereactDateRange from "../../../../../../components/core/date-range-primereact";

const BehavioralCampaignMajorDetails = ({
  behavioralVars,
  handleChange,
  lockerName,
}) => {
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions
  );

  return (
    <div className="w-full py-2">
      <div className="flex flex-col gap-3 px-[1.25rem]">
        <div className="grid grid-cols-12 w-full gap-3 items-center">
          <div className="col-span-6">
            <div className="grid grid-cols-12  items-center">
              <div className="col-span-4">
                <label>Campaign Name:</label>
              </div>
              <div className={"col-span-8"}>
                <Textfield
                  disabled={
                    accessPermission.behavioralCampaign === 1 ||
                    accessPermission.behavioralCampaign === "1"
                  }
                  name={"campaignName"}
                  value={behavioralVars.campaignName}
                  onChange={(event) => handleChange(event)}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-12 w-full gap-3 items-center">
          <div className="col-span-6">
            <div className="grid grid-cols-12  items-center">
              <div className="col-span-4">
                <label>Campaign Date:</label>
              </div>
              <div className={"col-span-8"}>
                <PrimereactDateRange
                  disabled={
                    accessPermission.behavioralCampaign === 1 ||
                    accessPermission.behavioralCampaign === "1"
                  }
                  timeOnly={true}
                  startDateName="startDate"
                  endDateName="endDate"
                  startTimeName="startTime"
                  endTimeName="endTime"
                  startDate={new Date(behavioralVars.startDate)}
                  endDate={new Date(behavioralVars.endDate)}
                  startTime={behavioralVars.startTime}
                  endTime={behavioralVars.endTime}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-12 w-full gap-3 items-center">
          <div className="col-span-6 ">
            {/* <div className="gap-2 items-center"> */}
            <div className="grid grid-cols-12  items-center">
              <label className="col-span-4">Locker Name:</label>

              <div className="col-span-8">
                <MultiSelect
                  disabled={
                    accessPermission.behavioralCampaign === 1 ||
                    accessPermission.behavioralCampaign === "1"
                  }
                  items={lockerName}
                  name={"lockerId"}
                  value={behavioralVars.lockerId}
                  // onChange={(e) => {
                  // 	handleChange();
                  // 	setSelectedLockerName(e.target.value);
                  // }}
                  onChange={handleChange}
                />
              </div>
            </div>
            {/* </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BehavioralCampaignMajorDetails;
